

export default function maskSensitiveInfo(str) {
    if(str)
        return str = str.replace(/\d(?=\d{4})/g, "*");
    else
        return str
}
